import Reveal from '@/components/base/Reveal';
import SectionTitle from '@/components/feature/SectionTitle';
import { guideGroups } from '@/mocks/indexNav';

type GuideIndexProps = {
  onSelectCategory: (id: string) => void;
};

export default function GuideIndex({ onSelectCategory }: GuideIndexProps) {
  return (
    <section id="guide" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        <Reveal>
          <SectionTitle
            kicker="Directory"
            title="按图索骥 · 指引列表全收录"
            desc="题材、热度、地区、时间四条索引线并行，像查目录一样逐层缩小范围，按指引直达目标分区。"
            action={{ label: '查看收录统计', href: '#overview' }}
          />
        </Reveal>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {guideGroups.map((group, index) => (
            <Reveal key={group.id} delay={index * 80}>
              <div className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-5">
                <div className="mb-4">
                  <h3 className="font-heading text-base font-bold text-foreground-950">{group.title}</h3>
                  <p className="mt-1 text-xs text-foreground-500">{group.subtitle}</p>
                </div>
                <ul className="flex flex-1 flex-col">
                  {group.items.map((item) =>
                    'category' in item && item.category ? (
                      <li key={item.label}>
                        <button
                          type="button"
                          onClick={() => onSelectCategory(item.category as string)}
                          className="group flex w-full items-center justify-between gap-2 border-b border-background-100 py-2 text-left text-sm text-foreground-700 cursor-pointer transition-colors last:border-b-0 hover:text-primary-600"
                        >
                          <span className="truncate">{item.label}</span>
                          <span className="font-label shrink-0 text-[11px] text-foreground-400 group-hover:text-primary-500">
                            {item.count}
                          </span>
                        </button>
                      </li>
                    ) : (
                      <li key={item.label}>
                        <a
                          href={item.href}
                          className="group flex items-center justify-between gap-2 border-b border-background-100 py-2 text-sm text-foreground-700 cursor-pointer transition-colors last:border-b-0 hover:text-primary-600"
                        >
                          <span className="truncate">{item.label}</span>
                          <span className="font-label shrink-0 text-[11px] text-foreground-400 group-hover:text-primary-500">
                            {item.count}
                          </span>
                        </a>
                      </li>
                    ),
                  )}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}